<template>
  <OnClickOutside @trigger="hide" :options="{ ignore: [/* ... */] }">
    <div class="menu-container" @click.stop>
      <div data-cy="menu-button" class="menu-button" v-click-outside="hide" @click="toggleMenu()">
        <img src="@/assets/Dots.svg" alt="dot" />
      </div>
      <div class="menu" :class="showMenu ? 'down' : ''">
        <div class="triangle-with-shadow" />
        <div class="main-rectangle">
          <ul @click.stop @click="hide" class="item-list">
            <li data-cy="menu-item" v-for="(item, index) in this.$slots.default" :key="index">
              <Vnode :vnode="item" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </OnClickOutside>
</template>

<script>

import { OnClickOutside } from '@vueuse/components'

export default {
  name: 'ActionsMenu',
  components: {
    OnClickOutside,
    Vnode: {
      functional: true,
      render(h, ctx) {
        return ctx.props.vnode
      }
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    hide() {
      this.showMenu = false
    }
  }
}
</script>

<style scoped lang="scss">

$shadow-color: rgba(69, 69, 69, 0.32);

.menu-container {
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 0.1rem;
  right: 0.5rem;

  .main-rectangle {
    background: white;
    box-shadow: 0 0 10px 0 $shadow-color;
    width: 100%;
  }

  .menu-button {
    font-size: 16px;
    cursor: pointer;
  }

  .menu {
    width: 100%;
    background-color: white !important;
    margin: 30px 0 0;
    position: absolute;
    right: 0; // fix for IE

    ul.item-list {
      margin: 0;
      list-style-type: none;
      padding-inline-start: 0;
      width: 100%;
      overflow: hidden;
      height: 0;
      padding: 0; // fix for IE

      li {
        color: $primary-color;
        width: 100%;
        cursor: pointer;

        &:hover {
          background-color: $primary-color;
          color: white;
        }
      }
    }

    .triangle-with-shadow {
      width: 100%;
      height: 0;
      position: absolute;
      overflow: hidden;
      top: -15px;
    }

    .triangle-with-shadow:after {
      content: "";
      position: absolute;
      width: 10px;
      height: 10px;
      background: white;
      transform: rotate(45deg); /* Prefixes... */
      top: 10px;
      right: 10px;
      box-shadow: 0 0 10px 0 $shadow-color;
    }
  }

  // applied css when user clicks on the 3 dots
  .menu.down {
    background-color: white;
    width: 130px;

    ul.item-list {
      height: unset;
    }

    .triangle-with-shadow {
      height: 15px;
    }
  }
}

</style>
